import { render, staticRenderFns } from "./InfoPuntosRealizados.vue?vue&type=template&id=0c945014&scoped=true"
import script from "./InfoPuntosRealizados.vue?vue&type=script&lang=js"
export * from "./InfoPuntosRealizados.vue?vue&type=script&lang=js"
import style0 from "./InfoPuntosRealizados.vue?vue&type=style&index=0&id=0c945014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c945014",
  null
  
)

export default component.exports